import { render, staticRenderFns } from "./ExaminationBodyAreas.vue?vue&type=template&id=065324b3&"
import script from "./ExaminationBodyAreas.vue?vue&type=script&lang=js&"
export * from "./ExaminationBodyAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports